import { render } from "./ProcessPanel.vue?vue&type=template&id=65ccb716&scoped=true"
import script from "./ProcessPanel.vue?vue&type=script&lang=js"
export * from "./ProcessPanel.vue?vue&type=script&lang=js"

import "./ProcessPanel.vue?vue&type=style&index=0&id=65ccb716&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ccb716"]])

export default __exports__